import React, { useEffect, useState } from 'react';
import { Paper, Box, Typography, CircularProgress } from '@mui/material';
import api from '../../services/api';
import { useAuth } from '../AuthProvider';

/**
 * Footer compacto com contagens — substitui os 8 ItemDashboard grandes
 * que estavam tomando muito espaço com pouca info.
 *
 * Cada item é uma "estatística inline" pequena (label cinza + número
 * vermelho), tudo numa linha quando o espaço permite.
 */
export default function CountersFooter() {
    const auth = useAuth();
    const [counters, setCounters] = useState({ loading: true });

    useEffect(() => {
        const endpoints = [
            { key: 'nas', url: '/dashboard/driade/nas', label: 'NAS', perm: 'nas.get_all' },
            { key: 'access', url: '/dashboard/driade/access', label: 'Acessos', perm: 'access.get_all' },
            { key: 'groups', url: '/dashboard/driade/groups', label: 'Grupos', perm: 'group.get_all' },
            { key: 'sessions', url: '/dashboard/driade/sessions', label: 'Sessões ativas', perm: 'log_session.get_all' },
            { key: 'servers', url: '/dashboard/oceanide/servers', label: 'Servidores DNS', perm: 'dns_node.get_all' },
            { key: 'acls', url: '/dashboard/oceanide/acls', label: 'ACL', perm: 'dns_acl.get_all' },
            { key: 'zones', url: '/dashboard/oceanide/local_zones', label: 'Zonas Locais', perm: 'dns_localzone.get_all' },
        ];

        const allowed = endpoints.filter((e) => auth.hasPerm(e.perm));
        Promise.all(allowed.map((e) =>
            api.get(e.url).then((r) => ({ ...e, value: r.data?.value ?? 0 })).catch(() => ({ ...e, value: '?' }))
        )).then((rows) => {
            setCounters({ loading: false, items: rows });
        });
    // eslint-disable-next-line
    }, []);

    if (counters.loading) {
        return (
            <Paper elevation={1} sx={{ m: 2, p: 1.5, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={20} />
            </Paper>
        );
    }

    if (!counters.items || counters.items.length === 0) return null;

    return (
        <Paper elevation={1} sx={{ m: 2, p: 1.5 }}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0, justifyContent: 'space-around' }}>
                {counters.items.map((c, i) => (
                    <Box
                        key={c.key}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            minWidth: 110,
                            px: 2,
                            py: 0.5,
                            borderRight: i < counters.items.length - 1 ? { md: '1px solid #eee' } : 'none',
                        }}
                    >
                        <Typography variant="h5" sx={{ fontFamily: 'Montserrat', fontWeight: 500, color: 'primary.main', lineHeight: 1.1 }}>
                            {typeof c.value === 'number' ? c.value.toLocaleString('pt-BR') : c.value}
                        </Typography>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', color: 'text.secondary', mt: 0.25, textAlign: 'center' }}>
                            {c.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
}
